<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <router-link :to="'/'" class="simple-text logo-mini"
         aria-label="sidebar mini logo">
          <div class="logo-img">
              <img :src="logo" alt="">
          </div>
      </router-link>
      <router-link :to="'/'" class="simple-text logo-normal">
          {{ title }}
      </router-link>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'

export default {
  props: {
    backgroundColor: {
      type: String,
      default: 'white',
      validator: (value) => {
        const acceptedValues = ['white', 'brown', 'black']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Sidebar background color (white|brown|black)'
    },
    activeColor: {
      type: String,
      default: 'primary',
      validator: (value) => {
        const acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Sidebar active text color (primary|info|success|warning|danger)'
    },
    logo: {
      type: String,
      default: '/static/img/logo.png',
      description: 'Sidebar Logo'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      title: this.$store.getters.siteName
    }
  },
  provide () {
    return {
      autoClose: this.autoClose
    }
  },
  methods: {
    async initScrollBarAsync () {
      const isWindows = navigator.platform.startsWith('Win')
      if (!isWindows) {
        return
      }
      const PerfectScroll = await import('perfect-scrollbar')
      PerfectScroll.initialize(this.$refs.sidebarScrollArea)
    }
  },
  mounted () {
    this.initScrollBarAsync()
  },
  beforeDestroy () {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
}

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
